<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="微信昵称" name='member_name'>
          <a-input v-model:value="search.member_name" style="width:270px" placeholder="微信昵称" />
        </a-form-item>
        <!-- <a-form-item label="开奖类型" name='open_award_type'>
          <a-select v-model:value="search.open_award_type" :style="{width:'180px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="2">一码多奖</a-select-option>
            <a-select-option :value="1">首次扫码</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' rowKey="activity_id" :loading='listLoading' bordered :columns='columns' :data-source='data'>
        <template v-slot:action="{ record }">
          <a-button type="danger"  size="small" href="javascript:;" class='m-r-10' v-has:marketingActivityScanActivityCollectDetail="()=>checkDetail(record)">详情</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
   <a-modal  :keyboard="false" :visible="detailVisible" title="资料详情" centered  @cancel="detailVisible=false" @ok="detailVisible=false">
      <ul>
        <li v-for="(v,k,index) in detail" :key="index">
          <span class="m-r-10 ">{{k}}:</span>
          <span>{{v}}</span>
        </li>
      </ul>
   </a-modal>
</template>
<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { iscode } from "@/utils/app";
import { inject, onMounted } from "@vue/runtime-core";
import {showCollectionInfo,getCollectionList} from '@/api/qrcodeActivitys'
export default {
  setup() {
    const state = reactive({
      listLoading: false,
      detailVisible:false,
      detailLoading:false,
      detail:{}
    });
    const search = ref({
      page: 1,
      limit: 10,
    });
    const total = ref(0);
    let data = ref([]);
    let columns = [
      {
        title: "微信昵称",
        dataIndex: "member_name",
        key: "member_name",
      },
      // {
      //   title: "开奖类型",
      //   dataIndex: "open_award_type_title",
      //   key: "open_award_type_title",
      // },
      {
        title: "码ID",
        dataIndex: "product_code",
        key: "product_code",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    const $route=inject('$route')
    const initData = async () => {
        state.listLoading = true;
         data.value=[]
        let res = await getCollectionList($route.query.activity_id,{...search.value,id:$route.query.activity_id}).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data;
          total.value = res.meta.total;
        }
        state.listLoading = false;
    };
    const checkDetail= async(data)=>{
      state.detailVisible=true
      state.detailLoading=true
     let result=await showCollectionInfo(data.id).then(res=>res.data).catch(error=>error)
      state.detailLoading=false
     if(iscode(result)){
       state.detail=result.data.info
     }else{
       iscode(result,true)
     }
    }
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    return {
      search,
      columns,
      data,
      ...toRefs(state),
      pageSearchChange,
      pageSizeChange,
      pageCurrentChange,
      total,
      checkDetail
    };
  },
};
</script>